import { Component, Input, Output, EventEmitter } from '@angular/core';
import {
  OfficeAssignment,
  ActionType,
} from '../office-assignment-config/office-assignment.model';

@Component({
  selector: 'irembogov-office-assignment-list',
  templateUrl: './office-assignment-list.component.html',
  styleUrls: ['./office-assignment-list.component.scss'],
})
export class OfficeAssignmentListComponent {
  @Input() assignments: OfficeAssignment[] = [];
  @Output() add = new EventEmitter<void>();
  @Output() edit = new EventEmitter<OfficeAssignment>();
  @Output() delete = new EventEmitter<OfficeAssignment>();

  getAssignmentTypeDisplay(type: string): string {
    switch (type) {
      case 'FIXED':
        return 'Fixed Office';
      case 'LOCATION_BASED':
        return 'Location Based';
      case 'MULTIPLE_LOCATION':
        return 'Multiple Locations';
      default:
        return type;
    }
  }

  getEndStateTypeDisplay(type: 'endStateOne' | 'endStateTwo'): string {
    switch (type) {
      case 'endStateOne':
        return 'End State One';
      case 'endStateTwo':
        return 'End State Two';
      default:
        return type;
    }
  }

  getActionTypeDisplay(actionType: ActionType): string {
    switch (actionType) {
      case 'breakingAction':
        return 'Breaking Action';
      case 'breakingActions':
        return 'Breaking Actions';
      case 'nonBreakingActions':
        return 'Non-Breaking Actions';
      default:
        return actionType;
    }
  }

  onAddNew() {
    this.add.emit();
  }

  onEdit(assignment: OfficeAssignment) {
    this.edit.emit(assignment);
  }

  onDelete(assignment: OfficeAssignment) {
    this.delete.emit(assignment);
  }
}
